<template>
  <div class="overflow-auto">
    <div class="w-full flex bg-white px-5 border-b-2 border-grey-light">
      <div
        :class="{
          'w-auto px-6 font-medium h-12 flex items-center justify-center border-b-2 border-transparent hover:text-primary cursor-pointer': true,
          'text-primary border-primary': activeFilter === APPROVAL_STATUS.PENDING,
        }"
        @click="setFilter(APPROVAL_STATUS.PENDING)"
      >
        Pending
      </div>
      <div
        :class="{
          'w-auto px-6 font-medium h-12 flex items-center justify-center border-b-2 border-transparent hover:text-primary cursor-pointer': true,
          'text-primary border-primary': activeFilter === APPROVAL_STATUS.APPROVED,
        }"
        @click="setFilter(APPROVAL_STATUS.APPROVED)"
      >
        Approved
      </div>
      <div
        :class="{
          'w-auto px-6 font-medium h-12 flex items-center justify-center border-b-2 border-transparent hover:text-primary cursor-pointer': true,
          'text-primary border-primary': activeFilter === APPROVAL_STATUS.REJECTED,
        }"
        @click="setFilter(APPROVAL_STATUS.REJECTED)"
      >
        Rejected
      </div>
    </div>
    <keep-alive>
      <component
        :is="activeFilter"
        :filter-type="filterType"
        :selected-index="selectedIndex"
      />
    </keep-alive>
  </div>
</template>

<script>
import Pending from './pending';
import Approved from './approved';
import Rejected from './rejected';
import {
  APPROVAL_STATUS,
} from '@constants';

export default {
  name: 'ApprovalStatus',
  page: {
    title: 'Approval Status',
  },
  components: {
    Pending,
    Approved,
    Rejected,
  },
  props: {
    filterType: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      APPROVAL_STATUS,
      activeFilter: APPROVAL_STATUS.PENDING,
      selectedIndex: 0,
    };
  },
  methods: {
    setFilter(filter) {
      this.activeFilter = filter;
      this.selectedIndex++;
    },
  },
};
</script>
